import { MEDIA_TYPES } from '@constants/mediaTypes'
import { IMedia } from '@dtos/Course'

/**
 * Diz se a mídia da aula tem linha do tempo instrumentada — ou seja, se o
 * player reporta os marcos de progresso (25/50/75/100) e portanto dá para
 * saber quando a reprodução chegou ao fim.
 *
 * Vídeo do Pandavideos e "HTML livre" (Embed) ficam de fora: o embed não expõe
 * tempo, então a aula é contada como concluída só por abrir e nunca chega um
 * marco de progresso.
 */
export function mediaReportsPlaybackProgress(media?: IMedia | null) {
  if (!media) return false
  if (media.type === 'Audio') return true
  if (media.type !== 'Video') return false

  return (
    media.host !== MEDIA_TYPES.PANDAVIDEOS && media.host !== MEDIA_TYPES.EMBED
  )
}
